import { IconProps } from "./IconProps"

const Icon: React.FC<IconProps> = ({ scale = 1 }) => (
  <svg
    width={64 * scale}
    height={42 * scale}
    viewBox="0 0 64 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Quote"
  >
    <path
      d="M34.9283 26.8891C34.9283 18.7961 47.2814 5.80406 51.4345 1.33147C53.0315 -0.372551 55.6937 -0.372551 57.2916 1.22524L57.3979 1.33147C58.8887 2.82229 58.8887 5.27142 57.5041 6.86915C55.6939 8.67939 54.096 10.7028 52.6052 12.6193C58.995 14.1093 64 19.9665 64 26.8888C64 34.8755 57.5041 41.4778 49.411 41.4778C41.3174 41.4778 34.9283 34.9818 34.9283 26.8888L34.9283 26.8891ZM14.6951 41.4781C22.6819 41.4781 29.2841 34.9822 29.2841 26.8891C29.2841 19.8606 24.2791 14.0034 17.6769 12.6196C19.2739 10.5961 20.8718 8.67968 22.5758 6.86954C24.0666 5.27248 23.9604 2.92958 22.4696 1.33185L22.3634 1.22562C20.7663 -0.478394 18.1041 -0.371426 16.5062 1.33185C12.3531 5.69814 0 18.7963 0 26.8895C0.10622 34.9826 6.60221 41.4785 14.6951 41.4785L14.6951 41.4781Z"
      fill="#C5A7F1"
    />
  </svg>
)

export default Icon
